import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Modal from '../components/modal.vue'
import type { IconPickerItem } from './icon-picker'

export const iconPickerModalProps = buildProps({
  // buildProps和defineprops一样
  /**
   * @description icon的value
   */
  value: {
    type: String,
    default: '',
  },
  /**
   * @description modal的visible
   */
  open: {
    type: Boolean,
  },
  data: {
    type: definePropType<IconPickerItem[]>(Array),
    default: () => [],
  },
} as const)

// props
export type IconPickerModalProps = ExtractPropTypes<typeof iconPickerModalProps> // ExtractPropTypes和defineCpmponent类似

// emits
export const iconPickerModalEmits = {
  'update:open': (value: boolean) => typeof value === 'boolean',
  changeIconValue: (value: string) => value,
}

// instance
export type IconPickerModalInstance = InstanceType<typeof Modal>
